export default __webpack_public_path__ + "static/0dfc6f1309fc0b88d68276f91f52ffaa.png";